import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface PromotionsGetSequences {
  id: string
  title: string
  shortDesc: string
  /**
    * @deprecated slug not recommendation again, change to type 'main-ads' or 'mini-ads'
  */
  slug: string
  type: string
  description: string
  createdAt: string
  updatedAt: string
  deletedAt: string
}

type useAllResult = {
  data: any
  result: PromotionsGetSequences[]
  total: number
}

type TQueryFnData = useAllResult
type TError = AxiosError

function useGetAllPromotions(
  page: number,
  pageSize: number,
  filter?: any,
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>
) {
  const urlQuery = useUrlQuery(urlOptions)

  const query = useQuery<TQueryFnData, TError>(
    urlQuery.transformKey(
      // will fix for future use
      `/documents-${page}-${pageSize}-${JSON.stringify(filter || [])}`,
    ),
    () =>
      ApiCall.Promotion.get(page, pageSize, filter).then((res) => {
        return res.data
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...options,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.total,
    helpers: urlQuery,
  }
}

export default useGetAllPromotions
